<template>
  <img src="/assets/img/pushone_logo.png" width="320" />
</template>